module.exports = __webpack_public_path__ + "img/users.a43207be.svg";